var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-layout-basic',[_c('div',{staticClass:"reset-password w-100 bsx-d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"w-5_12 h-100 bsx-d-flex bsx-flex-column align-items-center"},[_c('ed-reset-password')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }